import React from "react";
import { Link, useSearchParams } from "react-router-dom";

export default function AdminLogin() {
  const [params] = useSearchParams();
  const err = params.get("error");
  const onLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center px-5" data-testid="admin-login-page">
      <div className="w-full max-w-md border border-black/10 bg-white rounded-sm p-8">
        <Link to="/" className="text-xs uppercase tracking-widest text-neutral-500">← Back to store</Link>
        <h1 className="editorial font-serif-display text-3xl mt-6">Admin sign in</h1>
        <p className="text-neutral-600 mt-2 text-sm">Use your Google account to manage products, orders and files.</p>
        {err && <div className="mt-4 text-sm text-red-600" data-testid="admin-login-error">This account is not authorized to access the admin, or the admin has not been configured yet. Please contact the store owner.</div>}
        <button
          onClick={onLogin}
          className="pill-btn mt-8 w-full h-12 rounded-full bg-black text-white hover:bg-neutral-800 text-sm inline-flex items-center justify-center gap-2"
          data-testid="google-signin-btn"
        >
          <GoogleIcon /> Continue with Google
        </button>
        <div className="mt-4 text-[11px] text-neutral-500">
          Access is restricted to the single authorized admin account configured for this store.
          If you are not the store owner, please go back to the shop.
        </div>
      </div>
    </div>
  );
}

function GoogleIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 48 48" aria-hidden="true">
      <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.3 29.3 35 24 35c-6.1 0-11-4.9-11-11s4.9-11 11-11c2.8 0 5.3 1 7.3 2.7l5.7-5.7C33.7 6.5 29.1 4.5 24 4.5 13 4.5 4 13.5 4 24.5s9 20 20 20c11 0 20-9 20-20 0-1.4-.1-2.7-.4-4z"/>
      <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.5 16.1 18.9 13 24 13c2.8 0 5.3 1 7.3 2.7l5.7-5.7C33.7 6.5 29.1 4.5 24 4.5 16 4.5 9.2 9 6.3 14.7z"/>
      <path fill="#4CAF50" d="M24 44.5c5 0 9.5-1.9 12.9-5l-6-5c-1.8 1.3-4.1 2-6.9 2-5.2 0-9.6-3.3-11.2-8l-6.5 5C9.1 40 16 44.5 24 44.5z"/>
      <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.9 2.6-2.7 4.7-5.1 6.1l6 5c-.4.4 6.3-4.6 6.3-14.6 0-1.4-.1-2.7-.4-4z"/>
    </svg>
  );
}
